<p class="passage-text" [innerHTML]="text"></p>
